import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert } from '@reveni-io/reveni-ui'

import ShippingMethod from '@/configuration/components/ShippingMethod/ShippingMethod'

import ShippingMethodsSkeleton from './ShippingMethodsSkeleton/ShippingMethodsSkeleton'

const ShippingMethods = ({ shippingMethods, regions, loading }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (loading) return <ShippingMethodsSkeleton />

  if (!shippingMethods?.length) {
    return <Alert type="info">{t('Este criterio aún no está asociado a ningún método de envío.')}</Alert>
  }

  return (
    <>
      {shippingMethods.map((method, index) => (
        <ShippingMethod
          key={method.id}
          data={method}
          regions={regions}
          index={index}
          isEditable={false}
          showSwitch={false}
          customBackgroundColor={theme.colors.background.secondary}
          containerPadding={`${theme.spacing.sp8} ${theme.spacing.sp16}`}
        />
      ))}
    </>
  )
}

export default ShippingMethods
